import React, {useState} from 'react';
import {MoreLessToggleIcon} from '../custom/MoreLessToggleIcon';
import {CoefficientBox} from './CoefficientBox';
import {FixtureElement, GroupedMarketElements} from "../../models/api/codegen/code";
import {hex2rgba} from "../../utils/ColorUtils";
import {BoxHeader} from './BoxHeader';


type MarketVerboseProps = {
    groupedMarkets: GroupedMarketElements
    fixture: FixtureElement
    debug: boolean
    hasOverlay: boolean;
};

export function MarketVerbose(props: MarketVerboseProps) {
    const { groupedMarkets, fixture, debug, hasOverlay } = props;
    const [collapseGame, setCollapseGame] = useState(true);
    const isGroupCorrectScore = groupedMarkets.g === 'CORRECT_SCORE';
    const handleChange = () => setCollapseGame(prevState => !prevState);

    const ShowDuration = () => debug ? <>[{groupedMarkets.m[0].u}]</> : null;
    return (
        <div style={{backgroundColor: hex2rgba(fixture.sc, 0.1)}} className={`tablet:p-[8px] rounded-[4px] text-[14px] mb-[8px]`}>
            <div className="flex justify-between items-center font-medium" onClick={handleChange}>
                <div>{groupedMarkets.n} <ShowDuration /></div>
                <div>
                    <MoreLessToggleIcon isOpen={collapseGame} />
                </div>
            </div>
            {isGroupCorrectScore && collapseGame && <BoxHeader columnMapper={groupedMarkets?.m.length === 1 ? groupedMarkets.m[0].cm : undefined} />}
            {collapseGame && (
                <div
                    style={{gridTemplateColumns: `repeat(${groupedMarkets.m[0].c}, 1fr)`}}
                    className={`grid mt-[8px] [&>*]:mr-[8px] ml-2.5 ${hasOverlay ? "opacity-50 pointer-events-none" : ""}`}
                >

                    {groupedMarkets.m.map(market => (

                        <React.Fragment key={market.i}>
                            {market.sel
                                .map((selectionEl, index) => (
                                    <CoefficientBox
                                        key={index}
                                        isActive={market.s === 'ACTIVE' && !selectionEl.lc && !fixture.fsd}
                                        selectionEl={selectionEl}
                                        marketId={market.i}
                                        marketName={market.n}
                                        fixture={fixture}
                                        minRate={market.mi}
                                        maxRate={market.ma}
                                        isPlaceholder={selectionEl.ph}
                                        hasOverlay={hasOverlay}
                                    />
                                ))}
                        </React.Fragment>
                    ))}
                </div>
            )}
        </div>
    );
}
